
export default {
    data () {
        return {
            tagsList: []
        };
    },
    computed: {
        showTags () {
            return this.tagsList.length > 0;
        }
    },
    created () {
        let that = this;

        that.setTags(that.$route);

        that._onRemoveTag = function (path) {
            let idx = that.tagsList.findIndex(item => item.path === path);

            if (idx !== -1) {
                that.tagsList.splice(idx, 1);
                that.$bus.$emit('tags', that.tagsList);
            }
        };
        that.$bus.$on('removeTag', that._onRemoveTag);
    },

    beforeDestroy () {
        if (this._onRemoveTag) {
            this.$bus.$off('removeTag', this._onRemoveTag);
        }
    },
    methods: {
        // dict字典的翻译
        // generateTitle,

        isActive (path) {
            return path === this.$route.fullPath;
        },

        /**
         * [closeTags 关闭单个标签]
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        closeTags (index) {
            let that = this;

            let delItem = that.tagsList.splice(index, 1)[0];

            let item = that.tagsList[index] ? that.tagsList[index] : that.tagsList[index - 1];

            if (item) {
                delItem.path === that.$route.fullPath && that.$router.push(item.path);
            } else {
                that.$router.push('/');
            }
        },

        // 关闭全部标签
        // closeAll () {
        //     let that = this;

        //     that.tagsList = [];
        //     that.$router.push('/');
        // },

        // 关闭其他标签
        // closeOther () {
        //     let that = this;
        //     let curItem = that.tagsList.filter(item => {
        //         return item.path === that.$route.fullPath;
        //     });

        //     that.tagsList = curItem;
        // },

        /**
         * [setTags 设置标签]
         * @param {[type]} route [description]
         */
        setTags (route) {
            let that = this;
            let isExist = that.tagsList.some(item => {
                return item.path === route.fullPath;
            });

            // console.log(route);

            if (!isExist) {
                if (that.tagsList.length >= 6) {
                    that.tagsList.shift();
                }
                let title = route.name;
                
                if (route.name === 'CardPayLog' && route.params && route.params.cardNo) {
                    title = '交易记录·' + route.params.cardNo;
                }
                that.tagsList.push({
                    title: title,
                    path: route.fullPath
                    // name: route.matched[1].components.default.name
                });
            }
            that.$bus.$emit('tags', that.tagsList);
        },

        /**
         * [handleTags 标签函数]
         * @param  {[type]} command [description]
         * @return {[type]}         [description]
         */
        handleTags (command) {
            let that = this;

            command === 'other' ? that.closeOther() : that.closeAll();
        },

        fitlerSpeChar (str) {
            return str.replace('/', '');
        }
    },
    watch: {
        $route (newValue, oldValue) {
            this.setTags(newValue);
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/common/tags/tags.js